var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgModalCloseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.9998 8.3998L2.0998 13.2998C1.91647 13.4831 1.68314 13.5748 1.3998 13.5748C1.11647 13.5748 0.883138 13.4831 0.699805 13.2998C0.516471 13.1165 0.424805 12.8831 0.424805 12.5998C0.424805 12.3165 0.516471 12.0831 0.699805 11.8998L5.5998 6.9998L0.699805 2.0998C0.516471 1.91647 0.424805 1.68314 0.424805 1.3998C0.424805 1.11647 0.516471 0.883138 0.699805 0.699805C0.883138 0.516471 1.11647 0.424805 1.3998 0.424805C1.68314 0.424805 1.91647 0.516471 2.0998 0.699805L6.9998 5.5998L11.8998 0.699805C12.0831 0.516471 12.3165 0.424805 12.5998 0.424805C12.8831 0.424805 13.1165 0.516471 13.2998 0.699805C13.4831 0.883138 13.5748 1.11647 13.5748 1.3998C13.5748 1.68314 13.4831 1.91647 13.2998 2.0998L8.3998 6.9998L13.2998 11.8998C13.4831 12.0831 13.5748 12.3165 13.5748 12.5998C13.5748 12.8831 13.4831 13.1165 13.2998 13.2998C13.1165 13.4831 12.8831 13.5748 12.5998 13.5748C12.3165 13.5748 12.0831 13.4831 11.8998 13.2998L6.9998 8.3998Z",
    fill: "#231A3D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalCloseIcon);
export default __webpack_public_path__ + "static/media/modalCloseIcon.dbfeed5aded2342cbabcca6e71a7b388.svg";
export { ForwardRef as ReactComponent };